<script setup lang="ts">

</script>

<template>
    <div class="TextBlock">
        <slot />
    </div>
</template>


<style lang="scss" scoped>
.TextBlock {
    position: relative;
}
</style>
